export class Refund {
    id: string;
  organization_id: string;
  branch_id: string;
  invoice_id:string;
  invoice_no:string;
  date_time: string;
  price_offer: string;
  customer_id: string;
  customer_type:string;
  customer_name:string;
  invoice_type:string;
  delegate_type:string;
  delegate_id:string;
  delegate_name: string;
  items_from_branch_id: string;
  supplier_id: string;
  supplier_name: string;
  supplier_tax_num: string;


  total_free: string;
  customer_cash: string;
  paid: string;

  time:string;
  supplier_inv_num: string;
  supplier_inv_date: string;

  disc_type:string;
  disc_value:string;
  remain:string;
  import_date:string;
  collecting_customs_tax:any;

  inv_details:string;
  inv_payment_details:string;
  row_id:string;
  // cashier_operation:string
  // cashier_id:string
  start_date: string;
  end_date: string;

    last_on_behalf_of:string;
    showDeletedOnly: boolean;
  year:any;
    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/pro/refunds/refunds.ts